import { z } from 'zod';
import { firestoreTimestampSchema } from './user'; // Re-use from user.ts
import { 
  emailFieldSchema, 
  genericNameFieldSchema, 
  phoneFieldSchema,
  optionalEmailFieldSchema // In case invitedByUserEmail needs it
} from '@/utils/validationRules';

// Re-using a generic permission schema, adjust if invitation permissions are structured differently
const permissionSchema = z.object({
  name: z.string(),
  checked: z.boolean(),
  id: z.string(),
  description: z.string().optional(),
}).passthrough();

export const invitationSchema = z.object({
  email: emailFieldSchema, // Required email
  firstName: genericNameFieldSchema("First name").optional().nullable(),
  lastName: genericNameFieldSchema("Last name").optional().nullable(),
  phone: phoneFieldSchema.optional().nullable(),
  role: z.string(), // e.g., "Owner", "Manager" // TODO: Could use a Zod enum if roles are fixed
  status: z.string(), // e.g., "invited", "accepted", "removed" // TODO: Could use a Zod enum
  
  portfolioId: z.string().optional().nullable(), // Assuming it's primarily for portfolios based on context
  businessId: z.string().optional().nullable(), // Could also be for businesses

  permissions: z.array(permissionSchema).optional().nullable(),
  
  invitedAt: z.union([firestoreTimestampSchema, z.string().datetime().optional()]).optional().nullable(),
  createdAt: firestoreTimestampSchema,
  // acceptedAt, removedAt could also be fields depending on workflow
  
}).passthrough();

export type Invitation = z.infer<typeof invitationSchema>;
